import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M6 12q-.495 0-.847-.353A1.16 1.16 0 0 1 4.8 10.8v-8q0-.495.353-.848Q5.505 1.6 6 1.6h6.4q.495 0 .848.352.352.353.352.848v8q0 .495-.352.847A1.16 1.16 0 0 1 12.4 12zm0-1.2h6.4v-8H6zm-2.4 3.6q-.495 0-.847-.353A1.16 1.16 0 0 1 2.4 13.2V4.6q0-.255.172-.428A.57.57 0 0 1 2.997 4q.254 0 .428.172A.58.58 0 0 1 3.6 4.6v8.6h7q.255 0 .428.171a.57.57 0 0 1 .172.425.59.59 0 0 1-.172.429.58.58 0 0 1-.428.175z"
      />
    </g>
  </svg>
);
export default SvgStreamlineCopy;
